import script from "./Students.vue?vue&type=script&setup=true&lang=js"
export * from "./Students.vue?vue&type=script&setup=true&lang=js"

export default script